import styled from "styled-components";

export const RoundIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.text[p.color]};
  font-size: 1.3rem;
  opacity: ${(p) => (p.opacity ? p.opacity : 1)};
`;

export const RoundIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Counter = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background: rgba(215, 0, 0, 0.7);
  color: white;
  border-radius: 50%;
  font-size: 0.6rem;
  padding: 2px 6px;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;
